import { render, staticRenderFns } from "./SubmitScantronModal.vue?vue&type=template&id=48b38ac7&scoped=true&"
import script from "./SubmitScantronModal.vue?vue&type=script&lang=js&"
export * from "./SubmitScantronModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b38ac7",
  null
  
)

export default component.exports